// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#data-container {
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  max-height: 440px;
  overflow-y: auto;
}

.indicator {
  font-size: 20px;
  font-weight: 300;
  margin-top: -5px;
}

.indicator-green {
  color: green;
}

.indicator-red {
  color: red;
}

.indicator-gray {
  color: gray;
}`, "",{"version":3,"sources":["webpack://./src/satmon/modules/InfoComponent/LinkInfoComponent.scss"],"names":[],"mappings":"AAAA;EAEI,aAAA;EACA,kBAAA;EACA,uCAAA;EACA,iBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;;AAGA;EACI,UAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ","sourcesContent":["#data-container {\n    // background: white;\n    padding: 10px;\n    border-radius: 8px;\n    box-shadow: 0 0 10px rgba(0,0,0,0.1);\n    max-height: 440px;\n    overflow-y: auto;\n}\n\n.indicator {\n    font-size: 20px;\n    font-weight: 300;\n    margin-top: -5px;\n}\n\n.indicator-green{\n    color: green;\n}\n\n.indicator-red{\n    color: red;\n}\n\n.indicator-gray{\n    color: gray;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
